export default __webpack_public_path__ + "static/media/step2.07652dbb.svg";